export default __webpack_public_path__ + "static/media/1204.0c67dd64.png";